import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * FaqAccordion — accessible, single-open accordion. Each item: { q, a }.
 * `a` may contain JSX (used for inline links/CTAs) or plain text.
 */
export const FaqAccordion = ({ items = [], idPrefix = "faq" }) => {
  const [open, setOpen] = useState(0);
  if (!items.length) return null;
  return (
    <ul className="divide-y divide-border rounded-2xl border border-border bg-card overflow-hidden" data-testid="faq-accordion">
      {items.map(({ q, a }, i) => {
        const isOpen = open === i;
        const panelId = `${idPrefix}-panel-${i}`;
        const btnId = `${idPrefix}-btn-${i}`;
        return (
          <li key={i}>
            <button
              type="button"
              id={btnId}
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-muted/60 transition-colors"
              data-testid={`${idPrefix}-q-${i}`}
            >
              <span className="font-display text-base sm:text-lg">{q}</span>
              <ChevronDown className={`w-4 h-4 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
            </button>
            <div
              id={panelId}
              role="region"
              aria-labelledby={btnId}
              hidden={!isOpen}
              className="px-5 pb-5 text-sm sm:text-base text-foreground/80 leading-relaxed"
              data-testid={`${idPrefix}-a-${i}`}
            >
              {a}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
